import { render, staticRenderFns } from "./GlobalDialog.vue?vue&type=template&id=212120d7&scoped=true&lang=pug"
import script from "./GlobalDialog.vue?vue&type=script&lang=js"
export * from "./GlobalDialog.vue?vue&type=script&lang=js"
import style0 from "./GlobalDialog.vue?vue&type=style&index=0&id=212120d7&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "212120d7",
  null
  
)

export default component.exports